import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { font, breakpoint } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';

export const CrashCourseFilterSectionWrapper = styled.div<{ $inDropdown: boolean }>`
  ${({ $inDropdown }) =>
    $inDropdown &&
    `
    min-width: 200px;
  `}
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 36px;
`;

export const OptionsGroup = styled.div<{ theme: Theme }>`
  display: flex;
  flex-flow: column;
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
`;

export const OptionsGroupLabel = styled.label<{ $inDropdown: boolean; theme: Theme }>`
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: ${getColor('textPrimary')};
  ${({ $inDropdown }) =>
    $inDropdown &&
    `
    font-weight: 500;
    border-bottom: 1px solid ${getColor('borderPrimary')};
    text-align: center;
    padding: 8px 0px;
  `}
`;

export const OptionsGroupWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 8px;

  @media (${breakpoint.mmMin}) {
    margin-top: 24px;
  }

  .checkbox {
    width: 100%;
    position: relative;
    margin: 0;

    label {
      font-size: 24px;
      font-weight: 400;
      line-height: 29px;
      letter-spacing: 0.01em;
      padding: 16px 24px;
      width: 100%;
    }

    &:hover {
      background-color: ${brandColors.own.surfaceBrand};  
    }
  }
`;
